import {
  DiscoveryCardType,
  IMetadata,
  KissanEventType,
  useAppPersistenceStore,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  NoSearchResult,
  Paragraph,
  RootContainer,
  Separator,
  View,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { useFocusEffect, useRouter, Footer } from '@ninjacart/nc-nk-web-deps';
import { AnimatedFlashList, ViewToken } from '@shopify/flash-list';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDiscoveryMetadataApi } from '../../api/getDiscoveryMetadata';
// import { Animated, Dimensions } from 'react-native';
import { safeStringify } from '@ninjacart/nc-nk-core';
import { INinjaEvent, addEventParam, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { Platform } from 'react-native';
import { useDiscoveryStore } from '../../store/useDiscoveryStore';
import { AnimatedDiscoverHeader } from './animatedDiscoverHeader';
import { DiscoverPlaceHolder } from './discoverPlaceHolder';
import { VideoCardList } from './videoCardList';
import ViewAll from './viewAll';

export function VideosTabList() {
  const [size, setSize] = useState(0.5);
  const [data, setData] = useState<IMetadata[]>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(true);
  const [progress, setProgress] = useState(30);
  const { t } = useTranslation();
  const { push } = useRouter();
  const setDiscoveryFeeds = useDiscoveryStore((state) => state.setDiscoveryFeeds);
  const setSelectedDiscoveryFeedList = useDiscoveryStore(
    (state) => state.setSelectedDiscoveryFeedList
  );
  const appLanguageLabel = useAppPersistenceStore((state) => state.appLanguageLabel);
  const userProfile = useProfileStore((state) => state.userProfile);
  const deviceId = useProfileStore((state) => state.deviceId);
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const latitude = useProfileStore((state) => state.latitude);
  const longitude = useProfileStore((state) => state.longitude);
  const [visibleItemIndex, setVisibleItemIndex] = useState<number>(-1);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  // const scrollY = useRef(new Animated.Value(0)).current;
  // const offsetAnim = useRef(new Animated.Value(0)).current;
  const CONTAINER_HEIGHT = 48;
  // const clampedScroll = Animated.diffClamp(
  //   Animated.add(
  //     scrollY.interpolate({
  //       inputRange: [0, 1],
  //       outputRange: [0, 1],
  //       extrapolateLeft: 'clamp',
  //     }),
  //     offsetAnim
  //   ),
  //   0,
  //   CONTAINER_HEIGHT
  // );

  const getDiscoveryMetadata = async () => {
    try {
      setIsLoaded(true);
      const payload = {
        deviceIdOrUserId: uniqueDeviceId,
        geoLatitude: latitude,
        geoLongitude: longitude,
      };
      const res = await getDiscoveryMetadataApi(payload);
      if (res) {
        setData(res?.data);
        setDiscoveryFeeds(res?.data);
        setIsLoaded(false);
        discoveryPageOpenSuccessEvent();
      } else {
        console.log('API error here');
      }
    } catch (error) {
      const discoveryPageOpenFailedEvent: INinjaEvent = {
        name: KissanEventType.DIS_PAGEOPEN_FAIL,
        screenDetails: { screen: 'discovery page' },
        eventParams: [
          addEventParam('errorMessage', error.toString()),
          addEventParam('apiError', safeStringify(error)),
        ],
      };
      enqueue(discoveryPageOpenFailedEvent);
    }
  };

  const discoveryPageOpenSuccessEvent = () => {
    const discoveryPageOpenSuccessEvent: INinjaEvent = {
      name: KissanEventType.DIS_PAGEOPEN_SUCCESS,
      screenDetails: { screen: 'discovery page' },
    };
    enqueue(discoveryPageOpenSuccessEvent);
  };

  let _clampedScrollValue = 0;
  let _offsetValue = 0;
  let _scrollValue = 0;

  // scrollY.addListener(({ value }) => {
  //   const diff = value - _scrollValue;
  //   _scrollValue = value;
  //   _clampedScrollValue = Math.min(Math.max(_clampedScrollValue + diff, 0), CONTAINER_HEIGHT);
  // });
  // offsetAnim.addListener(({ value }) => {
  //   _offsetValue = value;
  // });

  let scrollEndTimer;
  const onMomentumScrollBegin = () => {
    clearTimeout(scrollEndTimer);
  };
  // const onMomentumScrollEnd = () => {
  //   const toValue =
  //     _scrollValue > CONTAINER_HEIGHT && _clampedScrollValue > CONTAINER_HEIGHT / 2
  //       ? _offsetValue + CONTAINER_HEIGHT
  //       : _offsetValue - CONTAINER_HEIGHT;

  //   Animated.timing(offsetAnim, {
  //     toValue,
  //     duration: 500,
  //     useNativeDriver: true,
  //   }).start();
  // };
  // const onScrollEndDrag = () => {
  //   scrollEndTimer = setTimeout(onMomentumScrollEnd, 250);
  // };

  const onEndReached = () => {
    const discoveryPagescrollVerticalEvent: INinjaEvent = {
      name: KissanEventType.DIS_PAGESCROLL_VERTICAL,
      screenDetails: { screen: 'discovery page' },
    };
    enqueue(discoveryPagescrollVerticalEvent);
  };

  // const headerTranslate = clampedScroll.interpolate({
  //   inputRange: [0, CONTAINER_HEIGHT],
  //   outputRange: [0, -CONTAINER_HEIGHT],
  //   extrapolate: 'clamp',
  // });

  // const opacity = clampedScroll.interpolate({
  //   inputRange: [0, CONTAINER_HEIGHT - 20, CONTAINER_HEIGHT],
  //   outputRange: [1, 0.05, 0],
  //   extrapolate: 'clamp',
  // });

  useFocusEffect(
    useCallback(() => {
      getDiscoveryMetadata();
      return () => {
        console.log('Discovery is being unfocused');
      };
    }, [appLanguageLabel])
  );

  const continueWatchSuccessEvent = (item: IMetadata) => {
    const disViewAllClickSuccess: INinjaEvent = {
      name: KissanEventType.DIS_VIEWALLCLICK_SUCCESS,
      screenDetails: { screen: item.type },
      eventParams: [addEventParam('discoveryViewAllCategories', item.type)],
    };
    enqueue(disViewAllClickSuccess);
  };

  const handleNavigation = (item: any) => {
    setSelectedDiscoveryFeedList(item);
    continueWatchSuccessEvent(item);
    if (item.type === DiscoveryCardType.CONTINUE_WATCHING) {
      push('/continueWatchViewAll');
    } else if (item.type.includes('playlists')) {
      push('/playList');
    } else {
      push('/trendingViewAllList');
    }
  };

  const viewabilityConfig = {
    itemVisiblePercentThreshold: 80,
    minimumViewTime: 1000,
  };

  const viewableItemsChanged = useCallback(
    ({ viewableItems }: { viewableItems: ViewToken[] }) => {
      if (viewableItems?.length > 0) {
        const filteredItems = viewableItems.filter(
          (item) => item?.item?.type != 'BANNER_AD' && !item?.item?.type.includes('playlist')
        );

        const newIndex = filteredItems.length > 0 ? filteredItems[0].index : -1;
        setVisibleItemIndex(newIndex!);

        viewableItems.forEach((item) => {
          const index = item.index;
          const type = item?.item?.type;
          if (index) {
            captureImpressionEvent(index!, type);
          }
        });
      }
    },
    [visibleItemIndex]
  );

  const captureImpressionEvent = (index: number, type: string) => {
    const dataViewedMoreThanOneSecEvent: INinjaEvent = {
      name: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
      screenDetails: { screen: 'discovery page' },
      eventParams: [addEventParam('scrolledIndex', index), addEventParam('type', type)],
    };
    enqueue(dataViewedMoreThanOneSecEvent);
    // console.log(`Impression event for item at index ${index} in DISCOVERY PAGE`);
  };

  const findRenderType = (item: IMetadata) => {
    switch (item.type) {
      case DiscoveryCardType.CONTINUE_WATCHING:
        return 'medium';
      case DiscoveryCardType.VIDEO_LIST:
      case DiscoveryCardType.TRENDING:
      case DiscoveryCardType.TRENDING_VIDEOS:
        return 'small';
      case DiscoveryCardType.CROPS:
        return 'crop-playlists';
      case DiscoveryCardType.MACHINERY:
        return 'machinery-playlists';
      case DiscoveryCardType.GOVTSCHEMES:
        return 'govt-scheme-playlists';
      case DiscoveryCardType.ANIMALS:
        return 'animal-playlists';
      case DiscoveryCardType.BANNER_AD:
        return 'ads';
      case DiscoveryCardType.CAROUSEL:
        return 'carousel';
      default:
        return 'small';
    }
  };

  const renderItem = ({ item, index }: { item: IMetadata; index }) => (
    <YStack marginTop={15} paddingHorizontal={12}>
      {item?.cardDetails?.name && <ViewAll item={item} handleNavigation={handleNavigation} t={t} />}
      <VideoCardList
        horizontal={true}
        cardWidth={230}
        renderItemType={findRenderType(item)}
        trendingFlag={item.type === DiscoveryCardType.TRENDING ? true : false}
        data={item}
        fullView={false}
        index={index}
        isActiveFeedIndex={index === visibleItemIndex}
      />
    </YStack>
  );

  const EmptyScreenPage = () => {
    return (
      <View
        backgroundColor={'$background'}
        justifyContent="center"
        alignItems="center"
        padding={16}
        marginVertical={20}
        borderRadius={50}
        marginTop={300}
      >
        {/* <Image
          source={{ uri: 'https://tecxsprts3.s3.amazonaws.com/1718971160101-sorry.png' }}
          height={100}
          width={'100%'}
        /> */}
        <NoSearchResult height={100} width={'100%'} />
        <Paragraph
          fontSize={22}
          fontWeight={'600'}
          color={'#18191A'}
          marginTop={20}
          marginBottom={10}
        >
          {t('page.sorry')}
        </Paragraph>
        <Paragraph
          fontSize={16}
          fontWeight={'400'}
          color={'#18191A'}
          paddingBottom={20}
          textAlign="center"
        >
          {t('page.weCouldnotFindMatchesForYourRequirement')}
        </Paragraph>
      </View>
    );
  };

  if (isLoaded) {
    return <DiscoverPlaceHolder />;
  }

  return (
    <RootContainer flex={1} marginBottom={'$0'}>
      <AnimatedDiscoverHeader
      // animatedValue={headerTranslate}
      // height={CONTAINER_HEIGHT}
      // opacity={opacity}
      />
      {!data?.length && <EmptyScreenPage />}
      <AnimatedFlashList
        data={data}
        contentContainerStyle={{ paddingTop: CONTAINER_HEIGHT, paddingBottom: 30 }}
        renderItem={renderItem}
        getItemType={(item, index) => {
          return findRenderType(item);
        }}
        keyExtractor={(item, index) => {
          return index.toString();
        }}
        scrollEventThrottle={24}
        // onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], {
        //   useNativeDriver: true,
        // })}
        // onMomentumScrollBegin={onMomentumScrollBegin}
        // onMomentumScrollEnd={onMomentumScrollEnd}
        // onScrollEndDrag={onScrollEndDrag}
        // ref={ref}
        estimatedItemSize={300}
        showsVerticalScrollIndicator={false}
        onEndReachedThreshold={0.7}
        onViewableItemsChanged={viewableItemsChanged}
        viewabilityConfig={viewabilityConfig}
        extraData={visibleItemIndex}
        // onEndReached={onEndReached}
        ListFooterComponent={() => {
          return Platform.OS === 'web' ? <Footer sourcepage={'videos'} /> : null;
        }}
        ItemSeparatorComponent={Separator}
      ></AnimatedFlashList>
    </RootContainer>
  );
}
